<readonly-access class="topics-part" [readonly]="!dialogDataService.hasVolunteerEditPermissions()"></readonly-access>

<grid-content id="volunteer-dialog-topics-grid" [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="topics()"></grid-content>